import React, { useContext, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import AuthProtected from "./AuthProtected";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import ProtectedRoute from "./ProtectedRoute";
import { PermissionsContext } from "pages/Authentication/PermissiosnProvider";

const Index = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error(
      "PermissionsComponent must be used within a PermissionsProvider"
    );
  }
  const { permissionsData } = context;
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route: any, idx: any) => (
            <Route
              path={route.path}
              element={
                <NonAuthLayout>
                  <ProtectedRoute
                    path={route.path}
                    element={route.component}
                    permissions={permissionsData}
                    routes={publicRoutes}
                  />
                </NonAuthLayout>
              }
              key={idx}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>
                    <ProtectedRoute
                      path={route.path}
                      element={route.component}
                      permissions={permissionsData}
                      routes={authProtectedRoutes}
                    />
                  </VerticalLayout>
                </AuthProtected>
              }
              key={idx}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
